import { StepConnector, stepConnectorClasses } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

/**
 * Line styling props for the member consent identity `StepConnector`.
 */
export interface ConsentIdentityStepConnectorProps {
  /** CSS width of the horizontal connector line (e.g. responsive `calc` or percent). */
  lineWidth: string;
}

/**
 * MUI `StepConnector` for the member consent identity stepper (line width, default and active line colors).
 * Renders in the design-system layer so `care_portal` feature code can avoid `sx` on this connector.
 *
 * @param props - `lineWidth` and any future design-system flags for the connector
 * @returns The `StepConnector` element to pass as a `Stepper` `connector`
 */
export const ConsentIdentityStepConnector = (props: ConsentIdentityStepConnectorProps) => {
  const { lineWidth } = props;
  const lineSx: SxProps<Theme> = {
    [`& .${stepConnectorClasses.line}`]: {
      position: 'relative',
      top: 7,
      left: '-12px',
      width: lineWidth,
      borderWidth: '1px',
      borderColor: '#021e38',
      borderStyle: 'solid',
    },
    [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#ff7b65',
      },
    },
  };
  return <StepConnector sx={lineSx} />;
};
